import { GET_BREADCRUMBS, GetBreadcrumbs } from '../types/breadcrumbs'
import { FilterApplied } from '../types/filters'

export const getBreadcrumbs = (value: FilterApplied[]): GetBreadcrumbs => {
  return {
    type: GET_BREADCRUMBS,
    payload: value,
  }
}
